import React from "react";
import "./NavigationBar.css";

const NavigationBar = ({ goToNextMove, goToPreviousMove, redrawThenGoToMove }) => {
  return (
    <div className="navigation-bar">
      <button className="navigation-bar button" onClick={() => redrawThenGoToMove(0)} title="Go to Start">
        <img src="/icons/start.svg" alt="Go to Start" />
      </button>
      <button className="navigation-bar button" onClick={() => goToPreviousMove()} title="Step Back">
        <img src="/icons/back.svg" alt="Step Back" />
      </button>
      <button className="navigation-bar button" onClick={() => goToNextMove()} title="Step Forward">
        <img src="/icons/forward.svg" alt="Step Forward" />
      </button>
      <button className="navigation-bar button" onClick={() => redrawThenGoToMove(-1)} title="Go to End">
        <img src="/icons/end.svg" alt="Go to End" />
      </button>
    </div>
  );
};

export default NavigationBar;
